import React from "react";
import SwapIcon from "../SwapIcon/SwapIcon";
import { SwapIconContainer, SwitchContainer, SwitchText } from "./CryptoInputSwitcher.styles";

export type CryptoInputSwitcherProps = {
  switcherLabel: string;
  onSwitch?: () => void;
}

const CryptoInputSwitcher: React.FC<CryptoInputSwitcherProps> = ({
  switcherLabel,
  onSwitch,
}) => {
  return (
    <SwitchContainer onClick={onSwitch}>
      <SwapIconContainer>
        <SwapIcon
          width={9}
          height={9}
        />
      </SwapIconContainer>
      <div>
        <SwitchText>
          {switcherLabel}
        </SwitchText>
      </div>
    </SwitchContainer>
  );
}

export default CryptoInputSwitcher;
